
import {Container as PixiContainer, DisplayObject, PointerEvents} from 'pixi.js';
import {EventCallbacks} from './types';

export const PIXI_CONTAINER_EVENTS = [
    'added',
    'childAdded',
    'childRemoved',
    'click',
    'clickcapture',
    'destroyed',
    'mousedown',
    'mousedowncapture',
    'mouseenter',
    'mouseentercapture',
    'mouseleave',
    'mouseleavecapture',
    'mousemove',
    'mousemovecapture',
    'mouseout',
    'mouseoutcapture',
    'mouseover',
    'mouseovercapture',
    'mouseup',
    'mouseupcapture',
    'mouseupoutside',
    'mouseupoutsidecapture',
    'pointercancel',
    'pointercancelcapture',
    'pointerdown',
    'pointerdowncapture',
    'pointerenter',
    'pointerentercapture',
    'pointerleave',
    'pointerleavecapture',
    'pointermove',
    'pointermovecapture',
    'pointerout',
    'pointeroutcapture',
    'pointerover',
    'pointerovercapture',
    'pointertap',
    'pointertapcapture',
    'pointerup',
    'pointerupcapture',
    'pointerupoutside',
    'pointerupoutsidecapture',
    'removed',
    'rightclick',
    'rightclickcapture',
    'rightdown',
    'rightdowncapture',
    'rightup',
    'rightupcapture',
    'rightupoutside',
    'rightupoutsidecapture',
    'tap',
    'tapcapture',
    'touchcancel',
    'touchcancelcapture',
    'touchend',
    'touchendcapture',
    'touchendoutside',
    'touchendoutsidecapture',
    'touchmove',
    'touchmovecapture',
    'touchstart',
    'touchstartcapture',
    'wheel',
    'wheelcapture'
] as const;

export type ContainerEvent = typeof PIXI_CONTAINER_EVENTS[number];

export type ContainerEventProps = {
    [K in ContainerEvent]?: EventCallbacks<(...data: any[]) => void>;
};